import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { RequestService } from '../request.service';
import { BaseResource } from '../../core/abstractions/base.resource';
import { ResourceConfig } from '../../core/models/resource.config';
import { TableStateModel } from '../../models/table-state.model';
import { UrlParameterModel } from '../../core/models/url-parameter.model';

@Injectable({
    providedIn: 'root'
})
export class TableStateResource extends BaseResource<TableStateModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const requestService = inject(RequestService);

        super(
            new ResourceConfig<TableStateModel>({
                requestService,
                baseController: 'tablestate'
            })
        );
    }

    getCurrent(): Observable<TableStateModel[]> {
        return this.config.requestService.makeGet<TableStateModel[]>(
            this.getUrl('')
        );
    }

    validateFullSync(lastFullSync: Date): Observable<boolean> {
        const params: UrlParameterModel[] = [
            new UrlParameterModel({
                key: 'lastFullSync',
                value: lastFullSync.toISOString()
            })
        ];

        return this.config.requestService.makeGet<boolean>(
            this.getUrl('validate-full-sync'),
            undefined,
            undefined,
            this.isAbsoluteUrl,
            ...params
        );
    }
}
